import React from "react";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/utils";
import { Share2 } from "lucide-react";

export function WhatsAppIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.6 1.9 6.5L4 29l7.8-2c1.8 1 3.9 1.5 6 1.5h.2c6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.8c-1.8 0-3.6-.5-5.2-1.4l-.4-.2-4.6 1.2 1.2-4.5-.2-.4a9.7 9.7 0 0 1-1.5-5.2c0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8zm5.4-7.3c-.3-.1-1.7-.9-2-1s-.5-.1-.7.1-.8 1-1 1.2-.4.2-.7.1a8 8 0 0 1-2.4-1.5 9 9 0 0 1-1.6-2c-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.4.3-.6s0-.4 0-.6l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1 1-1 2.5 1.1 2.9 1.2 3.1c.2.2 2.1 3.3 5.2 4.6 2.6 1 3.1.8 3.7.8s1.9-.8 2.1-1.5.2-1.4.2-1.5-.3-.2-.6-.3z" />
    </svg>
  );
}

export function FloatingWhatsApp({ phone }) {
  const { t } = useApp();
  if (!phone) return null;
  return (
    <a href={waLink(phone, t("wa_help_msg"))} target="_blank" rel="noreferrer" data-testid="wa-float"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-2xl hover:scale-105 transition-transform print:hidden">
      <WhatsAppIcon className="w-6 h-6" /><span className="text-sm font-semibold hidden sm:inline">{t("need_help")}</span>
    </a>
  );
}

export function ShareWhatsApp({ text, testid = "share-wa", label }) {
  const { t } = useApp();
  return (
    <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid={testid}>
      <Button variant="outline" className="rounded-full border-emerald-300 text-emerald-700 hover:bg-emerald-50"><Share2 className="w-4 h-4 mr-2" />{label || t("share_wa")}</Button>
    </a>
  );
}
